import { render, staticRenderFns } from "./transaction.vue?vue&type=template&id=48f595d8&scoped=true"
import script from "./transaction.vue?vue&type=script&setup=true&lang=js"
export * from "./transaction.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f595d8",
  null
  
)

export default component.exports